// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"95fe1c657a4e4a46","5763":"d7f9488bb495ef55","6893":"a462b52c4928d4d8","6974":"1fee3494b599dee3","7222":"ef5c2370cdf27894","7937":"83226c73f8b03f37"}[chunkId] + ".js";
};